import { UpdateWellSearchHistoryParams } from '../../models/UpdateWellSearchHistoryParamsModel';
import api from '../../services/api';

export const fetchAssetGroupSearchHistoryService = async () => {
    try {
        return await api
            .get(`/WellSearchHistory`, {
                headers: {
                    'content-type': 'application/json',
                },
            })
            .then(function (response: any) {
                if (response) {
                    return response.data;
                }
            });
    } catch (error) {
        console.error('Error fetching initial state:', error);
        return [];
    }
};

export const updateWellSearchHistoryService = async (updateWellSearchHistory: UpdateWellSearchHistoryParams) => {
    try {
        const payload = {
            searchType: updateWellSearchHistory.searchType,
            assetGUID: updateWellSearchHistory.assetGUID,
            assetId: updateWellSearchHistory.assetId,
            assetName: updateWellSearchHistory.assetName,
            industryApplicationId: updateWellSearchHistory.industryApplicationId,
            wellOpType: updateWellSearchHistory.wellOpType,
            groupName: updateWellSearchHistory.groupName,
            enabled: updateWellSearchHistory.enabled
        };

        return await api
            .post(`/WellSearchHistory`, JSON.stringify(payload), {
                headers: {
                    'content-type': 'application/json',
                },
            })
            .then(function (response: any) {
                if (response) {
                    return response.data;
                }
            });
    } catch (error) {
        console.error('Error updating well search history:', error);
        throw error;
    }
}
